var CRcarrierServiceEnabled = true;


// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var noSpecialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Grab-n-Go Subscription'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } /*else {
    noSpecialProduct1 = true;
  }*/

 
}

document.addEventListener('crJQActivated', function (e) {
  if (specialProduct1 === false) {
    jqCR('.pickup-wrapper').remove()
  }
})